import { ROOT_PREFIX } from 'shared/constants/white-label-constant';
import { WhiteLabelSubDomain } from 'shared/interfaces/WhiteLabelDomain';

export const buildDomainUrl = (subDomain: string, domain: string, withProtocol = true) => {
  return `${withProtocol ? 'https://' : ''}${subDomain ? `${subDomain}.` : ''}${domain}`;
};

export const filterOutRootSubDomain = (subDomains: WhiteLabelSubDomain[]) => {
  return subDomains.filter((subDomain) => subDomain.prefix !== ROOT_PREFIX);
};
